<template>
	<div :class="['comment-list', className]">
		<div class="userinfo">
			<div class="userinfo-l">
				<img :src="item.discussHeadPic || item.answerHeadPic || require('@/assets/default-avatar.png')"/>
			</div>
			<div class="userinfo-r">
				<div class="username-wrap">
					<div class="username" @click="toDetail(item.discussUserId)">{{item.discussUserName || item.answerUserName}}</div>
					<div class="level" v-if="item.circleLevel">
						<img :src="item.circleLevel">
					</div>
				</div>
				<div v-if="item.userClass == 1" class="user-type">官方账号</div>
				<!-- <div class="userinfo-tips">创作萌新 · 小米13 Ultra</div> -->
			</div>
		</div>
		<div class="comment-cnt" @click="toComment">
			{{item.content}}
		</div>
		<div v-if="(type == 'QUESTION')&&item.answerPicList&&item.answerPicList.length>0">
				<div class="img-wrap">
						<div v-for="(itemImg,index) in item.answerPicList" :key="index">
								<el-image
								style="width: 200px; height: 200px"
								:src="itemImg"
								fit="contain"
								:preview-src-list="answerPicList"></el-image>
						</div>
				</div>
		</div>
		<div class="article-card-bottom">
			<div class="bottom-l">
				<div class="article-viewcnt">
					<span>{{item.addTime | datefmt('yyyy-MM-DD')}}</span>
					<!-- <span>重庆</span> -->
				</div>
			</div>
			<div class="bottom-r">
				<div class="article-num" v-if="type == 'QUESTION' && isShow == false" @click.stop="toCommentList(item)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                    <span>{{item.discussNum}}</span>
                </div>
				<div class="article-num" :class="{active: item.isLike==1}" @click.stop="isLikeOrCancel(item)">
					<svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m7-2V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/></svg>
					<span>{{item.praiseNum}}</span>
				</div>
				<!-- <div class="article-num" v-if="item.isReport==0 && type != 'QUESTION'" @click.stop="isReporOrCancel(item)">
					<img src="@/assets/report.png"/>
				</div>
				<div class="article-num" v-if="item.isReport==1 && type != 'QUESTION'" @click.stop="isReporOrCancel(item)">
					<img src="@/assets/report_active.png"/>
				</div>
				<div class="article-num" v-if="item.isMineDiscuss==1" @click.stop="isDelOrCancel(item)">
					<img src="@/assets/del.png"/>
				</div> -->
				<div class="article-num active"  v-if="type == 'FEEDBACK' && item.meetFlag == 1">
						<div class="plus-one">
								<span>+1</span>
						</div>
						<span>我也遇到过</span>
				</div>
				<div class="article-num" v-if="type == 'FEEDBACK' && item.meetFlag == 0" @click.stop="feedbackDoMeet(item)">
						<div class="plus-one">
								<span>+1</span>
						</div>
						<span>我也遇到过</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'commentList',
		components: {},
		props: {
			item: {
				type: Object,
				value: {}
			},
			type:{
				type: String,
				value: ''
			},
			isShow:{
				type: Boolean,
				value: false
			},
			className: {
				type: String,
				value: ''
			}
		},
		data() {
			return {
				userId: ''
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
		},
		methods: {
      toDetail(id) {
        this.$router.push({
          path: '/userIndex?id=' + id
        })
      },
			toComment(){
				if(this.type == 'QUESTION'){
					return
				}
				this.$emit('toComment', {
					item: this.item
				})
			},
			//点赞 取消点赞评论
			async isLikeOrCancel(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {}
				let url = ''
				if(this.type == 'QUESTION'){
					param = {
						userId: this.userId,
						answerId: item.id
					}
					url='v1/circle/answerLike'
				}else{
					param = {
						userId: this.userId,
						discussId: item.id
					}
					url='v1/circle/discussLike'
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200){
					console.log(res)
					if(item.isLike==1) {
						this.$message.success('取消点赞成功！')
						item.praiseNum--
					} else {
						this.$message.success('点赞成功！')
						item.praiseNum++
					}
					item.isLike = item.isLike==1?0:1

				} else {
					this.$message.error(res.data.msg)
				}
			},
			// 举报
			async isReporOrCancel(item){
				console.log(item)
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					discussId: item.id
				}
				ajaxParam(param)
				const res = await post('v1/circle/reportDiscuss', qs.stringify(param))
				if(res.data.code==200){
					if(item.isReport==1) {
						this.$message.success('取消举报成功！')
					} else {
						this.$message.success('举报成功！')
					}
					item.isReport = item.isReport==1?0:1

				} else {
					this.$message.error(res.data.msg)
				}
			},
			// 删除
			async isDelOrCancel(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				this.$confirm('确定删除自己的评论?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
						this.todel(item)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});

			},
			async todel(item){
				let param = {
					userId: this.userId,
					discussId: item.id
				}
				ajaxParam(param)
				const res = await post('v1/circle/delDiscuss', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success('删除成功！')
					item.praiseNum--
					this.$emit('getComment')
				} else {
					this.$message.error(res.data.msg)
				}
			},

			async feedbackDoMeet(item){
				if (!this.userId) {
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					meetUserId: item.discussUserId,
					postId: item.id,
				}
				ajaxParam(param)
				const res = await post('v1/circle/feedbackDoMeet', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('反馈成功！')
					this.$emit('getComment')
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toCommentList(item){
				window.open('/questionDetail?id=' + item.id + '&type=' + this.type, '_blank')
			}
		}
	}
</script>

<style scoped lang="less">
	.comment-list {
		border-bottom: 1px solid var(--color-border);
		padding-bottom: 10px;
		margin-bottom: 20px;
		&.last{
			border-bottom: none;
		}
		.userinfo {
			display: flex;
			.userinfo-l img {
				width: 32px;
				height: 32px;
				border-radius: 50%;
			}

			.userinfo-r {
				display: flex;
				flex-direction: column;
				justify-content:center;
				margin-left: 6px;
				.username-wrap {
					display: flex;
					align-items: center;
					.username {
						font-weight: bold;
            cursor: pointer;
					}
				}
				.userinfo-tips {
					opacity: .7;
					font-size: 12px;
				}
			}
		}
		.comment-cnt{
			padding-top: 10px;
			word-break: break-word;
			overflow-wrap: anywhere;
			white-space: pre-wrap;
		}
		.article-card-bottom{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 6px 0;
			font-size: 12px;
			.bottom-l{
				display: flex;
				align-items: center;
				.article-viewcnt span{
					margin-right: 15px;
					color: var(--color-text-opacity);
				}
			}
			.bottom-r{
				display: flex;
				align-items: center;
				.article-num {
					display: flex;
					align-items: center;
					gap: 4px;
					margin-left: 25px;
					color: var(--color-text-opacity);
					cursor: pointer;
					flex-shrink: 0;

					.icon {
						width: 18px;
						height: 18px;
						flex-shrink: 0;
						opacity: .6;
					}

					span {
						font-size: 12px;
					}
					.plus-one{
						width: 18px;
						height: 18px;
						border-radius: 50%;
						border: 1px solid var(--color-text-opacity);
						text-align: center;
						line-height: 16px;
						span{
							font-size: 12px;
							opacity: 1;
						}
					}
					&.active{
						color: #DD0515;
						.icon {
							opacity: 1;
							fill: #DD0515;
							stroke: #DD0515;
						}
						.plus-one{
							border-color: #DD0515;
							color: #DD0515;
						}
					}
				}
			}
		}
	}

.level{
		margin-left:5px;
		img{
			height:16px;
			margin-top: 0;
		}
	}

.userinfo-tips {
	margin-top: 2px;
	opacity: .7;
	font-size: 12px;
	cursor: pointer;
}
.user-type {
	display: inline-block;
	width: 60px;
	height: 18px;
	padding: 0 4px!important;
	background: rgba(247, 125, 42, .18);
	border-radius: 4px;
	color: #F77D2A;
	font-size: 12px;
	line-height: 18px;
	text-align: center;
	margin-top: 2px;
}
</style>
